import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { setLang } from "../redux/slices/generalSlice";

const SITE_LANGS = ["en", "es", "ms"];

export default function SiteLanguageSelect({ sx }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.general?.lang) || "en";
  const value = SITE_LANGS.includes(lang) ? lang : "en";

  return (
    <Select
      value={value}
      onChange={(event) => dispatch(setLang(event.target.value))}
      size="small"
      aria-label={t("common.language")}
      sx={{
        color: "#fff",
        minWidth: 200,
        bgcolor: "rgba(255,255,255,0.08)",
        borderRadius: 2,
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255,255,255,0.35)",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(255,255,255,0.7)",
        },
        "& .MuiSvgIcon-root": { color: "#fff" },
        ...sx,
      }}
    >
      {SITE_LANGS.map((code) => (
        <MenuItem key={code} value={code}>
          {t(`languages.${code}`)}
        </MenuItem>
      ))}
    </Select>
  );
}
